import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { getDepartmentData } from '../../service/adminApi';

function Departments() {
    const [departmentList, setDepartmentList] = React.useState([]);
    let breadCrumbs = [
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Department Management', path: '', isActive: false },
    ];

    React.useEffect(() => {
        getDepartments();
    }, []);

    const getDepartments = async () => {
        const response = await getDepartmentData();
        setDepartmentList(response.data.data);
    };

    const renderDepartmentData = () => {
        return departmentList.map((department) => {
            return (
                <tr className="table-data-clr font-12 regular-text">
                    <td className="text-left font-light-blue align-middle">{department.department_name}</td>
                    <td className="text-end font-light-blue align-middle">{department.user_count}</td>
                </tr>
            );
        });
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbs} />
            <h5 className="bold-text tt-bold font-18 mb-4">Departments Management</h5>
            <div className="department-bg-height">
                <div className="row">
                    <div className="col-md-12 body-bg pb-5">
                        <div className="tab-content" id="pills-tabContent">
                            {/*All Leave Request Section Starts Here*/}
                            <div
                                className="tab-pane fade show active"
                                id="all_leave_request"
                                role="tabpanel"
                                aria-labelledby="all_leave_request_tab"
                            >
                                <div className="table-responsive">
                                    <table className="table bg-white hive-grid table-borderless ">
                                        <thead className="hive-table-head ">
                                            <tr>
                                                <th className="table-head bold-text font-12">Department Name</th>
                                                <th className="table-head text-end bold-text font-12"># of Users</th>
                                            </tr>
                                        </thead>
                                        <tbody>{renderDepartmentData()}</tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Departments;
